import { PaymentAndDeliveryContent } from './loaders';

export const PaymentAndDelivery = () => <PaymentAndDeliveryContent />;
